"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ECorporationRegimeFiscalTrads = void 0;
exports.ECorporationRegimeFiscalTrads = {
    is: "IS",
    ir: "IR",
    nonAssujetti: "Non assujetti (association)",
};
